<nz-list [nzSize]="size" [nzSplit]="split" [class]="'app-message-thread-list app-message-thread-list-' + size">
  @for (messageThread of messageThreads; track messageThread.id) {
  <nz-list-item class="app-message-thread-list-item" [ngClass]="{ 'app-message-thread-list-item-selected': isMessageThreadSelected(messageThread.id) }">
    <a class="app-message-thread-list-item-content" (click)="selectMessageThread(messageThread.id)">
      @if (displayFrom) {
      <div class="app-message-thread-list-item-content-title" [params]="{ bankName }" translate>messages.customerService</div>
      }
      <div class="app-message-thread-list-item-content-date">{{ messageThread.lastMessageCreatedAt | appDate: locale.language }}</div>
      <div class="app-message-thread-list-item-content-subject">
        <span>{{ messageThread.subject }}</span>
        <app-image name="attach" [hidden]="!messageThread.hasAttachments"></app-image>
      </div>
    </a>
    <ul nz-list-item-actions class="app-message-thread-list-item-actions">
      <nz-list-item-action>
        <nz-badge nzStandalone [nzCount]="messageThread.messageCount?.unread"></nz-badge>
      </nz-list-item-action>
    </ul>
  </nz-list-item>
  }
</nz-list>
